/*
 * Public API Surface of defaultExt
 */

export * from './lib/extension.module';
export * from './lib/hivemessage/hivemessage.module';
export * from './lib/hivemessage/services/hivemessage.service';
export * from './lib/hivemessage/components/hivemessage-modal.component';
export * from './lib/hivemessage/components/mobile-phone-hivemessage.component';
